// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"225":"template","272":"order-form"}[chunkId] || chunkId) + "." + {"225":"3b2ebec8","272":"7c71956c","846":"35008f2d"}[chunkId] + ".js";
};